import React, { useEffect } from 'react';

const LiveChat = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://res.public.onecdn.static.microsoft/customerconnect/v1/7dttl/init.js';
    script.id = 'chatbot';
    script.setAttribute('environmentId', 'bb5feaf4-b0be-ea85-ab24-318af9b5ce0d');
    script.setAttribute('crossorigin', 'anonymous');
    
    // Append script to document body
    document.body.appendChild(script);
    
    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.getElementById('chatbot')) {
        document.body.removeChild(script);
      }
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  return null; // This component doesn't render any visible elements
};

export default LiveChat;